import React from 'react';
import { Col, Row } from '../../../../../components/base/BootstrapComponents/BootstrapComponents';
import { PROCEDURE_TYPE, VEHICLE_REGISTRY_BASIS_TYPE } from '../../../../../configs';
import { infoFormatterIntl } from '../../../../../utils/formatters';

export default function VehicleRegistryBasisView(props) {
  const {
    fieldsValidation = {},
    procedure,
    currentApplication = {},
  } = props;

  const applicant_new = currentApplication?.applicant_new || {};
  const {
    applicant_exemption,
    score_localization,
  } = applicant_new;

  const hasScoreLocalizationData = applicant_exemption === VEHICLE_REGISTRY_BASIS_TYPE.EXEMPTION_3;

  if (![PROCEDURE_TYPE.PROCEDURE_1227_6].includes(procedure)) {
    return null;
  }

  return (
    <>
      <div className="f4 mt-3">Основание внесения ТС в Реестр ЛТ</div>

      <Row className="row-cols-1">
        {infoFormatterIntl(
          'applicant.exemption',
          applicant_exemption,
          fieldsValidation,
          'applicant_new.applicant_exemption',
        )}
      </Row>
      {hasScoreLocalizationData && (
        <Row className="row-cols-1">
          {infoFormatterIntl(
            'new.score_localization',
            score_localization,
            fieldsValidation,
            'applicant_new.score_localization',
          )}
        </Row>
      )}
      <div className="hr-row mt-3" />
    </>
  );
}
